export default "__VITE_PUBLIC_ASSET__f15077fa__"